import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, profileComplete } from "@/context/AuthContext";
import { startCheckout } from "@/lib/billing";
import { BUY_KEY, loadProgress, markStep, setFlag, useOnboarding } from "@/lib/onboarding";
import { Spotlight } from "@/components/tour/Spotlight";
import { ProductTour } from "@/components/tour/ProductTour";

const OLD = 7 * 864e5;

export const TourHost = () => {
  const { status, user, profile } = useAuth();
  const { pathname } = useLocation();
  const s = useOnboarding();
  const [spot, setSpot] = useState(false);
  const [product, setProduct] = useState(false);
  const authed = status === "authed";

  useEffect(() => { if (authed && user) loadProgress(user.user_id || user.id || user.email); }, [authed, user]);
  useEffect(() => { if (authed && s.loaded && profileComplete(profile)) markStep("profile"); }, [authed, s.loaded, profile]);
  useEffect(() => { if (authed && s.loaded && pathname.startsWith("/wellbeing")) markStep("wellbeing"); }, [authed, s.loaded, pathname]);

  useEffect(() => {
    if (!authed) return;
    const raw = localStorage.getItem(BUY_KEY);
    if (!raw) return;
    localStorage.removeItem(BUY_KEY);
    try {
      const it = JSON.parse(raw);
      if (Date.now() - it.at < 36e5) { toast.message("Taking you to secure checkout…"); startCheckout(it.product, "/upgrade", undefined, it.interval); }
    } catch { /* ignore bad intent */ }
  }, [authed]);

  useEffect(() => {
    if (!authed || !s.loaded || s.tour_done_at || spot || !profileComplete(profile) || /^\/(onboarding|admin|login)/.test(pathname)) return;
    const created = Date.parse(user?.created_at || "");
    if (created && Date.now() - created > OLD) { setFlag("tour_done_at", new Date().toISOString()); return; }
    const t = setInterval(() => { if (!document.querySelector('[data-testid="trial-welcome"]') && document.querySelector('[data-testid="logo-link"]')) { clearInterval(t); setSpot(true); } }, 1200);
    return () => clearInterval(t);
  }, [authed, s.loaded, s.tour_done_at, spot, profile, pathname, user]);

  useEffect(() => {
    const f = (e) => (e.detail === "product" ? setProduct(true) : setSpot(true));
    window.addEventListener("rpopro:tour", f);
    return () => window.removeEventListener("rpopro:tour", f);
  }, []);

  return (
    <>
      {spot && authed && <Spotlight name={user?.name?.split(" ")[0]} onDone={() => { setSpot(false); if (!s.tour_done_at) setFlag("tour_done_at", new Date().toISOString()); }} onProductTour={() => setProduct(true)} />}
      <ProductTour open={product} onClose={() => setProduct(false)} authed={authed} />
    </>
  );
};
